/*globals Stripe*/

$('body').on('click', '.campaign-usd .donate-trigger', function () {
    $('.modal.add-donation-usd .select-ticket-trigger').removeClass('active');
    $('.modal.add-donation-usd').addClass('other');
    $('.add-donation-usd input[name="amount"]').val('0');
    $('.modal.add-donation-usd .other-amount input').select();
    openModal('.add-donation-usd');
    return false;
});

$('body').on('click', '.campaign-usd .scroll-down', function () {
    $('html, body').animate({
        scrollTop: $('.campaign-usd .lightpoints').offset().top
    }, 300);

    return false;
});

$('body').on('click', '.campaign-usd .to-tickets-trigger', function() {
    $('html, body').animate({
        scrollTop: $('.add-donation-usd').offset().top
    }, 300);
    
    return false;
});

function updateSummeryUSD() {
    var selected = $('.campaign-usd .select-ticket-trigger.active');
    var tickets = selected.length ? parseFloat(selected.attr('data-tickets')) : 0;
    var amount = parseFloat($('.campaign-usd [name="amount"]').val());

    if ($('.campaign-usd .promo').length) {
        var promo = $('.campaign-usd .promo');
        if(promo.attr('data-mode') == 'tickets') {
            tickets+= parseFloat(promo.attr('data-tickets'));
        }

        if (promo.attr('data-mode') == 'discount') {
            amount-= parseFloat(promo.attr('data-discount'));
        }
    }

    $('.campaign-usd .summery .total-amount').html(amount.toFixed(2));
    $('.campaign-usd .summery .total-tickets').html(tickets);
}

// validate the promo code
function validateUSDPromo() {
    $('.promo .code-error, .promo .invalid').hide();

    if ($('.add-donation-usd input[name="amount"]').length && parseFloat($('.add-donation-usd input[name="amount"]').val()) <= 0) {
        $('.promo .code-error').show();
        $('input[name="coupon"]').val('');
        return false;
    }

    $.ajax({
        type: 'POST',
        url: '/coupons',
        data: {
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': 'GET',
            'amount': $('.add-donation-usd input[name="amount"]').val(),
            'coupon': $('.add-donation-usd input[name="coupon"]').val()
        },
        dataType: 'json',
        success: function (data) {
            if (data.success) {
                $('.add-donation-usd .promo label').hide();
                // $('.add-donation-usd .promo .applied .code').html(data.code);
                // $('.add-donation-usd .promo .applied .tickets').html(data.tickets);
                $('.add-donation-usd .promo .applied').show();
                $('.add-donation-usd .promo .applied p').html(data.message);

                $('.add-donation-usd .promo').attr('data-mode', data.mode);
                $('.add-donation-usd .promo').attr('data-tickets', data.tickets);
                $('.add-donation-usd .promo').attr('data-discount', data.discount);
            } else {
                $('.add-donation-usd .promo .invalid').show();
                $('.add-donation-usd .promo label').show();
                $('.add-donation-usd .promo .applied').hide();
            }

            updateSummeryUSD();
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
}

$('body').on('click', '.campaign-usd .select-ticket-trigger', function() {
    var $this = $(this);
    var amount = $this.attr('data-amount');

    $('.campaign-usd .select-ticket-trigger').removeClass('active');
    $this.addClass('active');

    $('.campaign-usd .other-amount input').val(amount);
    $('.campaign-usd [name="amount"]').val(amount);
    $('.campaign-usd .select-ticket-trigger').removeClass('active');
    $('.campaign-usd .select-ticket-trigger[data-amount="' + amount + '"]').addClass('active');

    $('.add-donation-usd').removeClass('other');
    if ($this.parents('li').is(':last-child')) {
        $('.add-donation-usd').addClass('other');
    }

    updateSummeryUSD();
    $('.add-donation-usd .buy-tickets').addClass('visible');

    if ($('.campaign-usd .promo').length && $('.campaign-usd .promo input').val()) {
        validateUSDPromo();
    }

    $('html, body').animate({
        scrollTop: $('.add-donation-usd .buy-tickets').offset().top + 40
    }, 300);
    return false;
});

$('body').on('click', '.campaign-usd .close-other-amount', function() {
    $('.add-donation-usd').removeClass('other');
    $('.campaign-usd .select-ticket-trigger').removeClass('active');
    $('.campaign-usd .other-amount input').val('0');
    $('.campaign-usd [name="amount"]').val('0');
    updateSummeryUSD();
    return false;
});

$('body').on('blur', '.add-donation-usd .other-amount input', function() {
    var $this = $(this);
    var amount = parseFloat($this.val());
    amount = isNaN(amount) ? 0 : amount;
    $('.add-donation-usd [name="amount"]').val(amount);
    updateSummeryUSD();
    return false;
});

$('body').on('blur', '.add-donation-usd input[name="coupon"]', function() {
    validateUSDPromo();
    return false;
});

$('body').on('click', '.add-donation-usd .remove-coupon', function() {
    $('.campaign-usd .promo input').val('');
    $('.add-donation-usd .promo').attr('data-mode', '');
    $('.add-donation-usd .promo').attr('data-tickets', '');
    $('.add-donation-usd .promo').attr('data-discount', '');
    $('.add-donation-usd .promo .invalid').hide();
    $('.add-donation-usd .promo .applied').hide();
    $('.add-donation-usd .promo label').show();
    updateSummeryUSD();
    return false;
});


$('body').on('change', '.add-donation-usd [name="method"]', function() {
    var $this = $(this);
    var method = $this.val();
    
    if(method === 'card') {
        $('.add-donation-usd .card').parents('li').removeClass('hidden');
        $('.add-donation-usd .card').addClass('required');
        return false;
    }

    if(method === 'paypal') {
        $('.add-donation-usd .card').parents('li').addClass('hidden');
        $('.add-donation-usd .card').removeClass('required');
    }

});

// submit the donation
$('body').on('submit', '.add-donation-usd form', function() {
    var $this = $(this);

    var amount = parseFloat($('.add-donation-usd input[name="amount"]').val());
    amount = isNaN(amount) ? 0 : amount;
    if(!amount) {
        showNotice('Error', 'Please choose a ticket amount', 'close');
        return false;
    }

    var error = false;
    var emailError = false;
    $('.required', $this).each(function() {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Error', 'Please fill out all required fields', 'close');
        return false;
    }

    if (emailError) {
        showNotice('Error', 'Please enter a valid email address', 'close');
        return false;
    }

    loading();

    // check if we are paypal
    var payload = {};

    if ($('.add-donation-usd [name="method"]:checked').val() === 'paypal') {
        payload['_token'] = $('meta[name="csrf-token"]').attr('content');
        payload.first_name = $('input[name="first_name"]', $this).val();
        payload.last_name = $('input[name="last_name"]', $this).val();
        payload.street = $('input[name="street"]', $this).val();
        payload.city = $('input[name="city"]', $this).val();
        payload.state = $('input[name="state"]', $this).val();
        payload.zip = $('input[name="zip"]', $this).val();
        payload.email = $('input[name="email"]', $this).val();
        payload.phone = $('input[name="phone"]', $this).val();
        payload.coupon = $('input[name="coupon"]', $this).val();
        payload.amount = $('input[name="amount"]', $this).val();
        payload.source = $('input[name="source"]', $this).val();
        payload.method = $('input[name="method"]:checked', $this).val();

        $.ajax({
            type: 'POST',
            url: $this.attr('action'),
            data: payload,
            dataType: 'json',
            success: function (data) {
                console.log(data);
                
                if (!data.success) {
                    unloading();
                    showNotice('Error', data.message, 'close');
                    return false;
                }
                
                if(data.location) {
                    window.location.href = data.location;
                    return false;
                }
                
                unloading();
                $this[0].reset();
                closeModal();
                showNotice('Success', data.message, 'close');
            },
            error: function (request) {
                console.log(request.responseText);
            }
        });

        return false;
    }

    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    payload.first_name = $('input[name="first_name"]', $this).val();
    payload.last_name = $('input[name="last_name"]', $this).val();
    payload.street = $('input[name="street"]', $this).val();
    payload.city = $('input[name="city"]', $this).val();
    payload.state = $('input[name="state"]', $this).val();
    payload.zip = $('input[name="zip"]', $this).val();
    payload.email = $('input[name="email"]', $this).val();
    payload.phone = $('input[name="phone"]', $this).val();
    payload.coupon = $('input[name="coupon"]', $this).val();
    payload.amount = $('input[name="amount"]', $this).val();
    payload.source = $('input[name="source"]', $this).val();
    payload.method = $('input[name="method"]:checked', $this).val();

    payload.card_number = $('input[name="card_number"]', $this).val();
    payload.cvv = $('input[name="cvv"]', $this).val();
    payload.month = $('input[name="month"]', $this).val();
    payload.year = $('input[name="year"]', $this).val();

    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);

            if (!data.success) {
                unloading();
                showNotice('Error', data.message, 'close');
                return false;
            }

            if (data.location) {
                window.location.href = data.location;
                return false;
            }

            unloading();
            $this[0].reset();
            closeModal();
            showNotice('Success', data.message, 'close');
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });


    // // setup the token
    // Stripe.setPublishableKey($('meta[name="stripe"]').attr('content'));
    // Stripe.card.createToken(
    //     {
    //         name: $('input[name="first_name"]', $this).val() + ' ' + $('input[name="last_name"]', $this).val(),
    //         number: $('input[name="card_number"]', $this).val(),
    //         cvc: $('input[name="cvv"]', $this).val(),
    //         exp_month: $('input[name="month"]', $this).val(),
    //         exp_year: $('input[name="year"]', $this).val(),
    //         address_line1: $('input[name="street"]', $this).val(),
    //         address_state: $('input[name="state"]', $this).val(),
    //         address_zip: $('input[name="zip"]', $this).val()
    //     },
    //     function(status, response) {
    //         // console.log(response);
    //         if (response.error) {
    //             unloading();
    //             showNotice('Error', response.error.message, 'close');
    //             return false;
    //         }

    //         payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    //         payload.stripe_token = response.id;

    //         payload.first_name = $('input[name="first_name"]', $this).val();
    //         payload.last_name = $('input[name="last_name"]', $this).val();
    //         payload.street = $('input[name="street"]', $this).val();
    //         payload.city = $('input[name="city"]', $this).val();
    //         payload.state = $('input[name="state"]', $this).val();
    //         payload.zip = $('input[name="zip"]', $this).val();
    //         payload.email = $('input[name="email"]', $this).val();
    //         payload.phone = $('input[name="phone"]', $this).val();
    //         payload.brand = response.card.brand;
    //         payload.last_four = response.card.last4;
    //         payload.month = response.card.exp_month;
    //         payload.year = response.card.exp_year;
    //         payload.coupon = $('input[name="coupon"]', $this).val();
    //         payload.amount = $('input[name="amount"]', $this).val();
    //         payload.source = $('input[name="source"]', $this).val();
    //         payload.method = $('input[name="method"]:checked', $this).val();

    //         $.ajax({
    //             type: 'POST',
    //             url: $this.attr('action'),
    //             data: payload,
    //             dataType: 'json',
    //             success: function(data) {
    //                 console.log(data);
    //                 unloading();

    //                 if (!data.success) {
    //                     showNotice('Error', data.message, 'close');
    //                     return false;
    //                 }

    //                 $this[0].reset();
    //                 closeModal();
    //                 showNotice('Success', data.message, 'close');
    //             },
    //             error: function(request) {
    //                 console.log(request.responseText);
    //             }
    //         });

    //         return false;
    //     }
    // );

    return false;
});

$('body').on('click', '.open-campaign-rules-usd', function () {
    openModal('.campaign-rules-usd');
    return false;
});